export default function Footer() {
  return (
    <footer className="bg-stone-800 text-white py-16 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <h4 className="text-xl font-serif mb-6">The Azalea Tokyo</h4>
            <p className="text-sm text-gray-300 leading-relaxed">
              〒100-0004<br />
              東京都千代田区大手町1-1-1<br />
              TEL: 03-1234-5678
            </p>
          </div>
          <div>
            <h5 className="text-sm tracking-widest uppercase mb-6">宿泊</h5>
            <ul className="space-y-3">
              <li><a href="#" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap">客室・スイート</a></li>
              <li><a href="#" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap">プレジデンシャルスイート</a></li>
              <li><a href="#" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap">特別プラン</a></li>
            </ul>
          </div>
          <div>
            <h5 className="text-sm tracking-widest uppercase mb-6">体験</h5>
            <ul className="space-y-3">
              <li><a href="#" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap">お食事</a></li>
              <li><a href="#" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap">スパ＆ウェルネス</a></li>
              <li><a href="#" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap">アート＆カルチャー</a></li>
              <li><a href="#" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap">イベント</a></li>
            </ul>
          </div>
          <div>
            <h5 className="text-sm tracking-widest uppercase mb-6">つながる</h5>
            <div className="flex space-x-4 mb-6">
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-gray-600 hover:border-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-gray-600 hover:border-white transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-gray-600 hover:border-white transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
            <a href="#" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap">
              ニュースレター登録
            </a>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400 mb-4 md:mb-0">
            © 2025 The Azalea Tokyo. All Rights Reserved.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap">プライバシーポリシー</a>
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap">利用規約</a>
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap">特定商取引法に基づく表記</a>
          </div>
        </div>
      </div>
    </footer>
  );
}